export const storeWallOfFameValues = (state, timelineValues, totalTimeline) => {
  return {
    ...state,
    wallOfFame: [...state.wallOfFame, ...timelineValues],
    total: totalTimeline,
  };
};

export const setWallOfFameLoader = (state, loaderValue) => {
  return {
    ...state,
    isLoading: loaderValue,
  };
};

export const updateWallOfFame = (state, post) => {
  const wallOfFameCopy = [...state.wallOfFame];

  wallOfFameCopy[
    wallOfFameCopy.findIndex((tPost) => {
      return tPost.id === post.id;
    })
  ] = {
    ...post,
  };

  return {
    ...state,
    wallOfFame: wallOfFameCopy,
  };
};

export const createWallOfFame = (state, post) => {
  var newWallOfFame = Array.from(new Set([post, ...state.wallOfFame]));

  return {
    ...state,
    total: state.total + 1,
    wallOfFame: newWallOfFame,
  };
};

export const deleteWallOfFame = (state, post) => {
  var newWallOfFame = state.wallOfFame.filter(
    (wallOfFame) => wallOfFame.id !== post.id
  );

  return {
    ...state,
    total: state.total - 1,
    wallOfFame: newWallOfFame,
  };
};

export const pageIncreamentWallOfFame = (state) => {
  var newPage = state.page + 1;

  return {
    ...state,
    page: newPage,
  };
};

export const clearAllWallOfFame = () => {
  return {
    wallOfFame: [],
    total: "",
    page: 1,
    isLoading: true,
  };
};
